import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ProductDetailPage from '../components/products/ProductDetailspage';

const Productdetails = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top when the component mounts
  }, []);

  return (
    <>
      <div><Navbar /></div>
      <div><ProductDetailPage /></div>
      <div><Footer /></div>
    </>
  );
};

export default Productdetails;
